import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ASStandardOringSizesService {
  private oringSizes;
  oringSizesData;
  private oringSizesJis;
  oringSizesJisData;
  constructor(private http: HttpClient) {}

  private oringSizesnData() {
    this.oringSizes = this.http.get('assets/calculations-json/AS standard Oring sizes.json');
  }

  private oringSizeJisData() {
    this.oringSizesJis = this.http.get('assets/calculations-json/JIS_standard_Oring_sizes.json');
  }

  getASStandardOringSizes () {
    if (!this.oringSizes) {
      this.oringSizesnData();
    }
    return this.oringSizes;
  }

  getASStandardOringSizesJis () {
    if (!this.oringSizesJis) {
      this.oringSizeJisData();
    }
    return this.oringSizesJis;
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/service/ASStandardOringSizesService.ts